import { crmRegistry } from "@/features/crm_system/lib/_core/crmRegistry";
import { useOrganizationStore } from "@/lib/zustand/useStore";
import { useMemo } from "react";

export function useGetOrganizationCrmSystems() {
    const { organization } = useOrganizationStore()
    const items = useMemo(
        () => organization ? crmRegistry.getOrgSystemsList(organization) : [],
        [organization]
    );
    return items;
}